import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

let ELEMENT_DATA = [];

@Injectable({
  providedIn: 'root'
})
export class PlanProtectionService {

  constructor(private http:HttpClient ) {

  }
  
  getListaPlanProtectionTramite(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetPPTramiteList`, body);
  }

  getListaPlanProtectionVigente(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetPPVigenteList`, body);
  }

  getDetallesPlanProtection(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetPPDetail`, body);
  }

  redimirServiciosGarantias(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}SaveServicesUsage`, body);
  }

  confirmarDatosPlanProtection(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}UpdatePPDetail`, body);
  }

  previewPdf(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}PreviewPP`, body);
  }

  getSucursales(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetSucursalesList`, body);
  }

  getHistorialGarantia(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetWarrantyDetail`, body);
  }

  getInventario(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}InventoryValidation`, body);
  }

  getDetalleSku(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetSkuData`, body);
  }

  validarKilometrajePlan(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}KmValidation`, body);
  }

  getLength(filter: string) {
    return of(this.getElement('').length)
      .pipe(delay(500), tap(_ => {  }));
  }

  getData(page: number, pageSize: number, sortField: string, sortDirection: string) {
    const factor = sortDirection == 'desc' ? -1 : sortDirection == 'asc' ? 1 : 0
    return factor ? of(this.getElement('')
      .sort((a: any, b: any) => a[sortField] > b[sortField] ? -factor : factor)
      .slice((page - 1) * pageSize, page * pageSize)).pipe(
        delay(500), tap(_ => { })) :
      of(this.getElement('')
        .slice((page - 1) * pageSize, page * pageSize)).pipe(
          delay(500), tap(_ => { }))
  }

  getElement(filter: string) {
    return !filter ? [...ELEMENT_DATA] : ELEMENT_DATA.filter(x => x.folio.indexOf(filter) >= 0)
  }

  setData(body: any) {
    ELEMENT_DATA = body
    this.data = body
  }

  getInfo(){
    return this.data
  }

  data = []
  
  getEstatusPP(){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetStatusPP`, {});
  }

  getMarcas(){
    return this.http.get<any>(`https://api.wheel-size.com/v2/makes/?user_key=794ca9c932af99b407fc7e0047241359&region=mxndm&region=ladm&region=usdm&region=sadm`)
  }

  getYear(marca, year){
    return this.http.get<any>(`https://api.wheel-size.com/v2/years/?user_key=794ca9c932af99b407fc7e0047241359&make=${marca}&region=mxndm&year=${year}&region=ladm&region=usdm&region=sadm`)
  }

  getModelos(marca){
    return this.http.get<any>(`https://api.wheel-size.com/v2/models/?user_key=794ca9c932af99b407fc7e0047241359&make=${marca}&region=mxndm&region=ladm&region=usdm&region=sadm`)
  }

  descargarReporteVigentes(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetPPVigenteExcel`, body);
  }

  descargarReporteEnTramite(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}GetPPTramiteExcel`, body);
  }
  // getMarcas(){
  //   return this.http.get<any>(`${environment.base}${environment.catalogos_port}GetMakes`)
  // }

  // getYear(marca, model){
  //   return this.http.get<any>(`${environment.base}${environment.catalogos_port}GetYears?make=${marca}&model=${model}`)
  // }

  // getModelos(marca){
  //   return this.http.get<any>(`${environment.base}${environment.catalogos_port}GetModels?make=${marca}`)
  // }
}